module.exports = __webpack_public_path__ + "static/img/309.a3f74f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/309.png
// module id = 518
// module chunks = 3